// test1128
(1128 && 0);
